module.exports = __webpack_public_path__ + "media/images/icon_sort_btn_date_on-017a39da3e3c085dcc3af4423a342c19.png";